/*
  Shared theme helpers. Loaded on every page with defer.
  Exposes window.JT = { fetchCart, formatMoney, on, emit }.
*/
(function () {
  'use strict';

  var body = document.body;
  var moneyFormat = body ? body.getAttribute('data-money-format') : null;

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';
    if (isNaN(cents) || cents == null) return '0';
    var value = (cents / 100).toFixed(precision);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || moneyFormat || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(placeholderRegex);
    var value;
    switch (match && match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }

  function cartUrl() {
    var el = document.querySelector('[data-cart-url]');
    return (el && el.getAttribute('data-cart-url')) || '/cart';
  }

  function fetchCart(url) {
    return fetch((url || cartUrl()) + '.js', {
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function on(name, fn) {
    document.addEventListener(name, fn);
    return function () { document.removeEventListener(name, fn); };
  }

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
  }

  window.JT = {
    fetchCart: fetchCart,
    formatMoney: formatMoney,
    on: on,
    emit: emit,
    moneyFormat: moneyFormat
  };
})();
